export default "__VITE_ASSET__CVLSW$4a__"